export function downloadHostLink() {
  return [
    {
      id: "1",
      btn: "../../hhpoker/index-download-ios",
      hostLink: "https://yybod.cvmnp.com/api/c/4bwrvc5i",
      describe: "downloadLink.iosHostLink"
    },
    {
      id: "2",
      btn: "../../hhpoker/index-download-android",
      hostLink:
        "https://download.litterzinc.com/apk/hp_279001_mobile_prod_202411041350_prod.apk",
      describe: "downloadLink.androidHostLink"
    },
  ]
}


export function downloadIos() {
  return [
    {
      id: "1",
      iosBtnImg: "../../hhpoker/iosHostBtn",
      url: "https://yybod.cvmnp.com/api/c/4bwrvc5i",
      flag: "../../hhpoker/recommend",
      describe: "downloadLink.iosHostLink"
    },
    {
      id: "2",
      iosBtnImg: "../../hhpoker/iosReservebtn1",
      url: "https://hhsjm.cvmnp.com/api/c/4308wgtl",
      describe: "downloadLink.iosAlternativeLink1"
    },
    {
      id: "3",
      iosBtnImg: "../../hhpoker/iosReservebtn2",
      url: "https://fzofg.vpxdl.cn/api/c/4bwrvc5i",
      describe: "downloadLink.iosAlternativeLink2"
    },
    {
      id: "4",
      iosBtnImg: "../../hhpoker/iosReservebtn3",
      url: "https://ybkan.vpxdl.cn/api/c/4308wgtl",
      describe: "downloadLink.iosAlternativeLink3"
    },
  ]
}
export function downloadAndroid() {
  return [
    {
      id: "1",
      androidBtnImg: "../../hhpoker/androidHostBtn",
      url: "https://download.litterzinc.com/apk/hp_279001_mobile_prod_202411041350_prod.apk",
      flag: "../../hhpoker/recommend",
      describe: "downloadLink.androidHostLink"
    },
    {
      id: "2",
      androidBtnImg: "../../hhpoker/androidReservebtn1",
      url: "https://download.litterzinc.com/apk/hp_279001_mobile_prod_202412101630.apk",
      describe: "downloadLink.androidAlternativeLink1"
    }
  ]
}


